import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface ReportFilter {
  code_start?: string;
  code_end?: string;
}

export interface ColorItem {
  code: string;           // f114_01
  name: string;           // f114_11
  english_name: string;   // f114_12
  old_code_flag: boolean; // f114_14
  remarks: string;        // f114_15
}

export interface ReportData {
  items: ColorItem[];
  total: number;
}

export interface ReportResponse {
  data?: ReportData;
  message?: string;
}

// ============================================================
// API Client
// ============================================================

export const p1314Api = {
  async query(filter: ReportFilter): Promise<ReportResponse> {
    const params: Record<string, string> = {};
    for (const [k, v] of Object.entries(filter)) {
      if (v && v.trim() !== '') {
        params[k] = v.trim();
      }
    }
    const res = await apiClient.get('/api/p1314/report', { params });
    return res.data;
  },
};
